import { render, staticRenderFns } from "./DiagnosesFilter.vue?vue&type=template&id=4cbd7226"
import script from "./DiagnosesFilter.vue?vue&type=script&lang=js"
export * from "./DiagnosesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports